import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { startRegisterSearchResult } from "./searchResultActions";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";
import { dispatchSearchFilterResults } from "../helpers/searchFilterDispatch.helper";
import { resolveFlowListQueryFromState } from "../helpers/flowModuleListQueryHelper";

/*Reorganizados*/

/* Metodos Principales */
export const technologyStartRegisterAdmin = (technology, navigate, returnTo) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_TECHNOLOGY}`,
      "add",
      technology,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: technologyActions, technologyStartRegisterAdmin', { 'body': body });

    if (body.ok) {

      const technologySaved = body.technology;
      dispatch(technologyRegisterAdmin(technologySaved));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            const nextPath = typeof returnTo === "string" && returnTo.startsWith("/")
              ? returnTo
              : "/specialist-technology";
            navigate(nextPath);
          }, 5000);
        }
      });

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const technologyRegisterAdmin = (technology) => ({
  type: types.TECHNOLOGY_START_REGISTER_ADMIN,
  payload: technology,
});

export const technologyStartUpdate = (technology, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_TECHNOLOGY}`,
        `update/${technology.id}`,
        technology,
        "PUT"
      );
      const body = await resp.json();

      debugLogActions(':: technologyActions, technologyStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(technologyUpdated(technology));

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        });

      } else {

        if (body.errors) {
          const { catalogserie_id } = body.errors;

          if (catalogserie_id) {
            Swal.fire(t("titles.error"), catalogserie_id.msg, "error");
            
          }
        }

        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: technologyActions, technologyStartUpdate', { 'error': error });
    }
  };
};

const technologyUpdated = (technology) => {
  return {
    type: types.TECHNOLOGY_UPDATE,
    payload: technology,
  };
};

export const technologyStartDelete = (id, onDeleted) => {
  return async (dispatch, getState) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_TECHNOLOGY}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {
              debugLogActions(':: technologyActions, technologyStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(technologyDeleted(id));
                if (typeof onDeleted === "function") {
                  onDeleted();
                }
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: technologyActions, technologyStartDelete', { 'error': error });
    }
  };
};

const technologyDeleted = (id) => {
  return {
    type: types.TECHNOLOGY_DELETE,
    payload: id,
  };
};

export const startLoadingTechnologiesPaginated = (page, size) => {
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'technology');
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_TECHNOLOGY}`, `get/${page}/${size}${query}`);
    const body = await resp.json();

    debugLogActions(':: technologyActions, startLoadingTechnologiesPaginated', { 'body': body });

    if (body.ok) {
      dispatch(loadingTechnologysPaginated(body.technologysPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingTechnologysPaginated = (technologysPaginated) => ({
  type: types.TECHNOLOGY_START_LOADING_PAGINATED,
  payload: technologysPaginated,
});

export const startLoadingTechnologiesByTextTechnologyPaginated = (technology, page, size, catalogToFilter, indicatorToFilter = [], codeCiiuLevel1 = {}) => {
  return async (dispatch, getState) => {

    const searchInfoObject = {
      searchTechnologyText: technology,
      codeCiiuLevel1: codeCiiuLevel1,
      catalogToFilter: catalogToFilter,
      indicatorToFilter: indicatorToFilter,
    };

    dispatch(technologyIsLoading());

    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_TECHNOLOGY}`,
        `getByTextTechnology/${page}/${size}`,
        searchInfoObject,
        "POST"
      );
      const body = await resp.json();

      debugLogActions(':: technologyActions, startLoadingTechnologiesByTextTechnologyPaginated', { 'body': body });

      if (body.ok) {
        dispatchSearchFilterResults(dispatch, body.filterResults);

        body.technologysPaginated.technologysP.forEach(element => {
          element.isSelected = false;
          element.isCompared = false;
        });

        dispatch(loadingTechnologiesByTextTechnologyPaginated(body.technologysPaginated));

        const { totalItems, totalPages, currentPage, technologysP } = body.technologysPaginated;

        let index = 0;
        let registerIds = "";
        technologysP.forEach(element => {
          if (index === 0) {
            registerIds = registerIds.concat(element.id);
          } else {
            registerIds = registerIds.concat(";", element.id);
          }
          index = index + 1;
        });

        const state = getState();
        const { searchInfo } = state.searchInfo;

        const searchResult = {
          filter_results: body.filterResults,
          total_items: totalItems,
          total_pages: totalPages,
          current_page: currentPage,
          search_results_ids: registerIds,
          deleted: false,
          searchinfo_id: searchInfo.id
        };

        dispatch(startRegisterSearchResult(searchResult));
      } else {
        if (body.code === "bak-error-001") {
          Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
        }
        if (body.code === "bak-aut-tok-inv-001") {
          Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: technologyActions, startLoadingTechnologiesByTextTechnologyPaginated', { error });
      Swal.fire(t("titles.error"), t("alerts.validation.bak-error-001"), "error");
    } finally {
      dispatch(technologyIsLoadingFinish());
    }
  };
};

const loadingTechnologiesByTextTechnologyPaginated = (technologysPaginated) => ({
  type: types.TECHNOLOGY_START_LOADING_TECHNOLOGY_PAGINATED,
  payload: technologysPaginated,
});

export const startSearchingTechnologiesPaginated = (textSearch, page, size) => {
  
  return async (dispatch, getState) => {
    const query = resolveFlowListQueryFromState(getState, 'technology');
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_TECHNOLOGY}`,
      `search/${textSearch}/${page}/${size}${query}`
    );
    const body = await resp.json();

    debugLogActions(':: technologyActions, startSearchingTechnologiesPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingTechnologiesPaginated(body.technologysPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const searchingTechnologiesPaginated = (technologysPaginated) => ({
  type: types.TECHNOLOGY_START_SEARCH_PAGINATED,
  payload: technologysPaginated,
});

export const selectTechnology = (technology) => ({
  type: types.TECHNOLOGY_SELECT,
  payload: technology,
});

export const cleanTechnologiesPaginatedS = () => ({
  type: types.TECHNOLOGY_CLEAN_SEARCH_PAGINATED,
});

export const cleanTechnologiesPaginatedP = () => ({
  type: types.TECHNOLOGY_CLEAN_PAGINATED,
});

export const technologySetSearchText = (searchText) => ({
  type: types.TECHNOLOGY_SET_SEARCH_TEXT,
  payload: searchText,
});

export const technologyCleanSearchText = () => ({
  type: types.TECHNOLOGY_CLEAN_SEARCH_TEXT,
});

export const technologyCleanSaved = () => ({
  type: types.TECHNOLOGY_CLEAN_SAVED,
});

//Si van update 13 de Febrero 2026
export const technologyListUpdateSelected = (id) => ({
  type: types.TECHNOLOGY_LIST_UPDATE_SELECTED,
  payload: id
});

export const technologyListSelectAllLimit = () => ({
  type: types.TECHNOLOGY_SELECT_ALL_LIMIT,
});

export const technologyCleanAllSelected = () => ({
  type: types.TECHNOLOGY_CLEAN_ALL_SELECTED,
});

export const technologyCleanAllSelectedWithoutList = () => ({
  type: types.TECHNOLOGY_CLEAN_ALL_WITHOUT_LIST,
});

export const technologyIsLoading = () => ({
  type: types.TECHNOLOGY_IS_LOADING
});

export const technologyIsLoadingFinish = () => ({
  type: types.TECHNOLOGY_IS_LOADING_FINISH
});


//No van update 13 de Febrero 2026
export const technologyGetMoreThanOneIsSelected = () => ({
  type: types.TECHNOLOGY_GET_MORE_THAN_ONE_SELECTED
});

export const technologyGetNumberTechnologySelected = (countCompareFlag) => ({
  type: types.TECHNOLOGY_LIST_SET_NUMBER_SELECTED,
  payload: countCompareFlag
});

export const cleanSearchInformation = () => ({
  type: types.TECHNOLOGY_CLEAN_SEARCH_INFORMATION,
});

export const cleanNumberOfTechnologiesSelected = () => ({
  type: types.TECHNOLOGY_CLEAN_NUMBER_OF_SELECTED,
});

export const cleanNumberOfTechnologiesCompared = () => ({
  type: types.TECHNOLOGY_CLEAN_NUMBER_OF_COMPARED,
});

export const cleanNumberOfTechnologiesSelectedCompared = () => ({
  type: types.TECHNOLOGY_CLEAN_NUMBER_OF_SELECTED_COMPARED,
});